import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-080d35a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__report-lesson px-12 md-down:px-4 pb-30" }
const _hoisted_2 = { class: "__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl gap-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    fill: "none",
    height: "28",
    viewBox: "0 0 28 28",
    width: "28",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M6.30003 19.6H19.6C22.2399 19.6 23.5598 19.6 24.3799 18.7799C25.2 17.9598 25.2 16.6399 25.2 14V7C25.2 4.36014 25.2 3.04021 24.3799 2.22011C23.5598 1.40001 22.2399 1.40001 19.6 1.40001H8.40003C5.76017 1.40001 4.44023 1.40001 3.62013 2.22011C2.80003 3.04021 2.80003 4.36014 2.80003 7V23.1C2.80003 21.167 4.36703 19.6 6.30003 19.6ZM9.80003 5.60001C8.25363 5.60001 7.00003 6.85361 7.00003 8.4C7.00003 9.9464 8.25363 11.2 9.80003 11.2L18.2 11.2C19.7464 11.2 21 9.9464 21 8.40001C21 6.85361 19.7464 5.60001 18.2 5.60001L9.80003 5.60001Z",
      fill: "#65758B",
      "fill-rule": "evenodd"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M5.51422 2.89003C4.90698 2.97168 4.71666 3.10348 4.61008 3.21006C4.50351 3.31663 4.3717 3.50696 4.29006 4.11419C4.203 4.7617 4.20003 5.64049 4.20003 7V18.6715C4.83651 18.3692 5.54851 18.2 6.30003 18.2H19.6C20.9595 18.2 21.8383 18.197 22.4858 18.11C23.0931 18.0283 23.2834 17.8965 23.39 17.7899C23.4965 17.6834 23.6284 17.4931 23.71 16.8858C23.7971 16.2383 23.8 15.3595 23.8 14V7C23.8 5.64049 23.7971 4.7617 23.71 4.11419C23.6284 3.50696 23.4965 3.31663 23.39 3.21006C23.2834 3.10348 23.0931 2.97168 22.4858 2.89003C21.8383 2.80298 20.9595 2.80001 19.6 2.80001H8.40003C7.04052 2.80001 6.16172 2.80298 5.51422 2.89003ZM1.40003 23.1V7C1.40003 6.96918 1.40003 6.93846 1.40003 6.90784C1.39996 5.66676 1.3999 4.59742 1.51503 3.7411C1.63841 2.82338 1.91666 1.94368 2.63018 1.23016C3.34371 0.516631 4.2234 0.238388 5.14112 0.115003C5.99745 -0.000126265 7.06679 -6.63454e-05 8.30787 3.41589e-06C8.33848 5.08482e-06 8.3692 6.75375e-06 8.40003 6.75375e-06L19.6922 3.41589e-06C20.9333 -6.63454e-05 22.0026 -0.000126265 22.8589 0.115003C23.7767 0.238388 24.6563 0.516631 25.3699 1.23016C26.0834 1.94368 26.3616 2.82337 26.485 3.7411C26.6002 4.59743 26.6001 5.66678 26.6 6.90788V14.0921C26.6001 15.3332 26.6002 16.4026 26.485 17.2589C26.3616 18.1766 26.0834 19.0563 25.3699 19.7698C24.6563 20.4834 23.7767 20.7616 22.8589 20.885C22.0026 21.0001 20.9333 21.0001 19.6922 21L6.30003 21C5.14023 21 4.20003 21.9402 4.20003 23.1C4.20003 24.2598 5.14023 25.2 6.30003 25.2H25.2C25.9732 25.2 26.6 25.8268 26.6 26.6C26.6 27.3732 25.9732 28 25.2 28H6.30003C3.59384 28 1.40003 25.8062 1.40003 23.1ZM9.80003 7C9.02683 7 8.40003 7.62681 8.40003 8.4C8.40003 9.1732 9.02683 9.8 9.80003 9.8L18.2 9.8C18.9732 9.8 19.6 9.1732 19.6 8.40001C19.6 7.62681 18.9732 7.00001 18.2 7.00001L9.80003 7ZM5.60003 8.4C5.60003 6.08041 7.48043 4.20001 9.80003 4.20001L18.2 4.20001C20.5196 4.20001 22.4 6.08041 22.4 8.40001C22.4 10.7196 20.5196 12.6 18.2 12.6H9.80003C7.48043 12.6 5.60003 10.7196 5.60003 8.4Z",
      fill: "#65758B",
      "fill-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Kho tài liệu ")
], -1))
const _hoisted_4 = { class: "items-center flex gap-3" }
const _hoisted_5 = {
  class: "search-input max-w-lg w-full",
  style: {"min-width":"160px"}
}
const _hoisted_6 = { class: "input-group input--lg" }
const _hoisted_7 = { class: "input-icon absolute top-1/2" }
const _hoisted_8 = { class: "w-full mb-10" }
const _hoisted_9 = { class: "border-b border-neutral-200" }
const _hoisted_10 = {
  "aria-label": "Tabs",
  class: "-mb-px flex space-x-8 tabs"
}
const _hoisted_11 = { class: "flex items-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
              class: "bg-white input-with-icon",
              placeholder: "Tìm theo tên tài liệu",
              type: "text",
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searching && _ctx.searching(...args))),
              onKeypress: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_DaIcon, {
                class: "h-4 w-4 text-neutral-400",
                name: "das--search"
              })
            ])
          ])
        ]),
        (_ctx.canCreateDocument)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button-p btn--ghost w-fit px-4",
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onCreateFlag += 1))
            }, " Tạo thư mục "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("nav", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: tab.id,
              to: {
							name: tab.link,
							query: {},
						},
              class: "border-transparent hover:text-yellow-700 hover:border-yellow-500 text-neutral-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, _toDisplayString(tab.name), 1)
                ])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view, {
        "on-create-flag": _ctx.onCreateFlag,
        onCreated: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCreateFlag = 0))
      }, null, 8, ["on-create-flag"])
    ])
  ]))
}